import React, { Component, Fragment } from 'react';
import DEFINE from "../../../../constants/Define";
import { Link } from 'react-router-dom';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import PopularPlaceList from './PopularPlaceList';
import Ripple from '../../common/component/Ripple';

let permisionActions = [];
export default class PopularPlaces extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                pageSize: this.props.popularPlacesState.pageSize,
                pageIndex: this.props.popularPlacesState.pageIndex,
            }
        };
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.POPULAR_PLACE);
        this.props.getListPopularPlaces(this.state.filters);
    }

    render() {
        const { t, match } = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, dataList } = this.props.popularPlacesState;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex, pageSize};
        return (
            <Fragment>
                <HMS.PageListComponent>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'popularPlaces'}
                        titleHeader={t('navigation.popularPlaces')}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate &&
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Link to={`/popular-places/action`}
                                        className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                </Ripple>
                            }
                            </Fragment>
                        }
                    />
                    <PopularPlaceList loading={isFetching}
                        permisions={permisionActions}
                        dataList={dataList}
                        pagination={pagination}
                        onChange={this.onTableChange}
                        onDeletePopularPlace={this.props.deletePopularPlace}
                        />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onTableChange = (pagination, filters, sorter) => {
        let curfilters = this.state.filters;
        if (filters.status) {
            switch (filters.status[0]) {
                case 998:
                    filters = Func.removeElementObject(filters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'isExpired');
                    filters.IsLocked = true;
                    break;
                case 999:
                    filters = Func.removeElementObject(filters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'IsLocked');
                    filters.isExpired = true;
                    break;
                default:
                    if (filters.status[0] !== 998) { curfilters = Func.removeElementObject(curfilters, 'IsLocked') }
                    if (filters.status[0] !== 999) { curfilters = Func.removeElementObject(curfilters, 'isExpired') }
            }
        }
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getListPopularPlaces(newFilters);
    };
}